<template>
  <teleport to="body">
    <div v-if="modelValue" class="booking-success-overlay" @click.self="closePopup">
      <transition name="fade">
        <div v-if="showPopup" class="booking-success-popup">
          <button type="button" class="close-btn" @click="closePopup">
            <span>X</span>
          </button>
          
          <div class="success-content">
            <!-- Green checkmark icon -->
            <div class="success-icon">
              <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="60" cy="60" r="55" stroke="#00CC6A" stroke-width="6" fill="none"/>
                <path d="M35 60L52 77L85 44" stroke="#00CC6A" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            
            <!-- Success title -->
            <h2 class="success-title">
              {{ $t('Kiosk.bookingDoneTitle') || 'Félicitations! Votre rendez-vous a été réservé avec succès..' }}
            </h2>
            
            <!-- Success message -->
            <p class="success-message">
              {{ $t('Kiosk.bookingDoneText') || 'Un SMS a été envoyé à votre numéro de téléphone pour confirmer votre réservation.' }}
            </p>
          </div>
        </div>
      </transition>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'LbrxBookingSuccessPopup',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    autoCloseDelay: {
      type: Number,
      default: 5000 // Auto close after 5 seconds
    }
  },
  emits: ['update:modelValue', 'close'],
  data() {
    return {
      showPopup: false,
      autoCloseTimer: null
    };
  },
  watch: {
    modelValue(val) {
      if (val) {
        setTimeout(() => {
          this.showPopup = true;
        }, 50);
        
        // Auto close after delay
        if (this.autoCloseDelay > 0) {
          this.autoCloseTimer = setTimeout(() => {
            this.closePopup();
          }, this.autoCloseDelay);
        }
      } else {
        this.showPopup = false;
        if (this.autoCloseTimer) {
          clearTimeout(this.autoCloseTimer);
          this.autoCloseTimer = null;
        }
      }
    }
  },
  methods: {
    closePopup() {
      this.showPopup = false;
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
      setTimeout(() => {
        this.$emit('update:modelValue', false);
        this.$emit('close');
      }, 300);
    }
  },
  beforeUnmount() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
  }
};
</script>

<style scoped>
.booking-success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
}

.booking-success-popup {
  position: relative;
  background: white;
  border-radius: 20px;
  padding: 40px 50px;
  max-width: 600px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.close-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  background: #A3A3A3;
  border: none;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  z-index: 10;
}

.close-btn span {
  color: white;
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
}

.close-btn:hover {
  background: #8a8a8a;
}

.success-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  margin-bottom: 30px;
  animation: scaleIn 0.5s ease-out;
}

.success-title {
  font-family: 'Exo 2', sans-serif;
  font-size: 23px;
  font-weight: 400;
  line-height: 31px;
  color: #00CC6A;
  margin: 0 0 20px 0;
  padding: 0 30px;
}

.success-message {
  font-family: 'Exo 2', sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  color: #BDBDBD;
  margin: 0;
  padding: 0 55px;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Scale in animation for icon */
@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .booking-success-popup {
    padding: 30px 25px;
    width: 85%;
  }
  
  .success-icon svg {
    width: 100px;
    height: 100px;
  }
  
  .success-title {
    font-size: 20px;
    line-height: 28px;
    padding: 0 15px;
  }
  
  .success-message {
    font-size: 18px;
    line-height: 24px;
    padding: 0 20px;
  }
  
  .close-btn {
    width: 45px;
    height: 45px;
  }
  
  .close-btn span {
    font-size: 26px;
  }
}
</style>
